// src/components/Legal/MetricsNotice.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const MetricsNotice = () => {
  return (
    <div className="container py-4 legal-page">
      {/* ================= ESPAÑOL ================= */}
      <h1>Aviso sobre fórmulas y marcas registradas</h1>

      <p>
        Tzone es una plataforma independiente para la planificación y el análisis del
        entrenamiento deportivo. Algunas métricas mostradas en la aplicación se inspiran en
        conceptos ampliamente utilizados en la industria del entrenamiento de resistencia.
      </p>

      <h2>1. Métricas tipo TSS, NP, IF</h2>
      <p>
        En la literatura de entrenamiento de resistencia se utilizan con frecuencia términos
        como <strong>Training Stress Score (TSS)</strong>, <strong>Normalized Power (NP)</strong>{' '}
        e <strong>Intensity Factor (IF)</strong>.
      </p>
      <p>
        <strong>
          TSS®, IF® y NP® son marcas registradas de Peaksware, LLC (TrainingPeaks®) en diversos
          países.
        </strong>{' '}
        Tzone no está afiliada, patrocinada ni respaldada por Peaksware, LLC ni por TrainingPeaks®,
        y el uso de dichas referencias se realiza únicamente con fines descriptivos.
      </p>
      <p>
        Cuando Tzone muestra métricas de carga de entrenamiento, estrés, potencia normalizada
        o intensidad, lo hace mediante <strong>implementaciones propias y aproximadas</strong>,
        diseñadas para uso educativo y de apoyo al entrenamiento, y no pretende sustituir a los
        productos oficiales de TrainingPeaks® ni reproducir de forma idéntica sus algoritmos.
      </p>

      <h2>2. Otras marcas y nombres comerciales</h2>
      <p>
        Garmin®, Garmin Connect™ y otros nombres de productos o servicios de Garmin son marcas
        comerciales o marcas registradas de Garmin Ltd. o sus subsidiarias, en Estados Unidos
        y otros países.
      </p>
      <p>
        Cualquier otra marca, logotipo o nombre comercial de terceros que aparezca en Tzone
        pertenece a sus respectivos titulares. El hecho de mencionarlos o integrarlos en Tzone
        no implica relación societaria, asociación, patrocinio ni respaldo entre Tzone y dichos
        titulares.
      </p>

      <h2>3. Finalidad informativa</h2>
      <p>
        Las métricas e indicadores que se muestran en Tzone tienen como objetivo ayudar a
        atletas y entrenadores a interpretar mejor la carga y el historial de entrenamiento.
        No constituyen asesoría médica ni garantizan ningún resultado deportivo específico.
        Cada usuario es responsable de utilizar la información de forma prudente y, en caso de
        duda, consultar con un profesional de la salud o del entrenamiento cualificado.
      </p>

      <hr className="my-4" />

      {/* ================= ENGLISH ================= */}
      <h1>Notice about formulas and registered trademarks</h1>

      <p>
        Tzone is an independent platform for planning and analysing sports training. Some of the
        metrics displayed in the application are inspired by concepts widely used in the
        endurance training industry.
      </p>

      <h2>1. TSS-, NP- and IF-type metrics</h2>
      <p>
        In endurance training literature, terms such as <strong>Training Stress Score (TSS)</strong>,{' '}
        <strong>Normalized Power (NP)</strong> and <strong>Intensity Factor (IF)</strong> are
        frequently used.
      </p>
      <p>
        <strong>
          TSS®, IF® and NP® are registered trademarks of Peaksware, LLC (TrainingPeaks®) in
          various countries.
        </strong>{' '}
        Tzone is not affiliated with, sponsored or endorsed by Peaksware, LLC or TrainingPeaks®,
        and any references to those terms are made for descriptive purposes only.
      </p>
      <p>
        When Tzone displays training load, stress, normalised power or intensity metrics, it does
        so using <strong>its own approximate implementations</strong>, designed for educational
        and training-support purposes. They are not intended to replace the official
        TrainingPeaks® products nor to reproduce their algorithms identically.
      </p>

      <h2>2. Other brands and trade names</h2>
      <p>
        Garmin®, Garmin Connect™ and other Garmin product or service names are trademarks or
        registered trademarks of Garmin Ltd. or its subsidiaries in the United States and other
        countries.
      </p>
      <p>
        Any other third-party brand, logo or trade name appearing in Tzone belongs to its
        respective owner. The fact that such names are mentioned or integrated in Tzone does not
        imply any corporate relationship, association, sponsorship or endorsement between Tzone
        and those owners.
      </p>

      <h2>3. Informational purpose</h2>
      <p>
        The metrics and indicators displayed in Tzone are intended to help athletes and coaches
        better interpret training load and history. They do not constitute medical advice and do
        not guarantee any specific performance outcome. Each user remains responsible for using
        the information prudently and, in case of doubt, consulting a qualified health or
        training professional.
      </p>

      {/* 🔙 Botón para volver al Home */}
      <div className="mt-4">
        <Link to="/home" className="btn btn-outline-primary btn-sm">
          Volver al inicio
        </Link>
      </div>
    </div>
  );
};

export default MetricsNotice;
